import { render, staticRenderFns } from "./EsqueciSenha.vue?vue&type=template&id=9ab95c4c&scoped=true"
import script from "./EsqueciSenha.vue?vue&type=script&lang=js"
export * from "./EsqueciSenha.vue?vue&type=script&lang=js"
import style0 from "./EsqueciSenha.vue?vue&type=style&index=0&id=9ab95c4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab95c4c",
  null
  
)

export default component.exports